import { MEDIA_URL, TRAVALOUR_URL } from "../../config";

export const mediaThumbnailUrl = (mediaId, width, height) => {
  return `${MEDIA_URL}/thumbnail/${mediaId}?width=${width}${!!height ? `&height=${height}` : ``
    }`;
};

export const mediaOriginalUrl = (mediaId) => {
  return `${MEDIA_URL}/get-original/${mediaId}`;
};

export const admAreaUrl = (admId, name, full) => {
  return `${full ? TRAVALOUR_URL : ""}/destination/${admId}-${name
    .toLowerCase()
    .replace(/[^A-Z0-9]+/gi, "-")
    .replace(/-$/, "")}`;
};

export const articleUrl = (articleId, title, full) => {
  return `${full ? TRAVALOUR_URL : ""}/article/${articleId}-${title
    .toLowerCase()
    .replace(/[^A-Z0-9]+/gi, "-")
    .replace(/-$/, "")}`;
};

export const activityUrl = (activityCode, name, full) => {
  return `${full ? TRAVALOUR_URL : ""}/activity/${activityCode}-${name
    .toLowerCase()
    .replace(/[^A-Z0-9]+/gi, "-")
    .replace(/-$/, "")}`;
};

export const activityDestinationUrl = (destinationId, name, full) => {
  return `${full ? TRAVALOUR_URL : ""}/activities/destination/${destinationId}-${name
    .toLowerCase()
    .replace(/[^A-Z0-9]+/gi, "-")
    .replace(/-$/, "")}`;
};

export const locationUrl = (locationId, name, full) => {
  return `${full ? TRAVALOUR_URL : ""}/attraction/${locationId}-${name
    .toLowerCase()
    .replace(/[^A-Z0-9]+/gi, "-")
    .replace(/-$/, "")}`;
};

export const userUrl = (username, full) => {
  return `${full ? TRAVALOUR_URL : ""}/u/${username.toLowerCase()}`;
};

export const travelCardUrl = (travelCardId, name, full) => {
  return `${full ? TRAVALOUR_URL : ""}/visit/${travelCardId}-${name
    .toLowerCase()
    .replace(/[^A-Z0-9]+/gi, "-")
    .replace(/-$/, "")}`;
};

export const tripUrl = (tripId, name, full) => {
  return `${full ? TRAVALOUR_URL : ""}/trip/${tripId}-${name
    .toLowerCase()
    .replace(/[^A-Z0-9]+/gi, "-")
    .replace(/-$/, "")}`;
};
